export const
    NEEDS_ANALYSIS = "Needs Analysis",
    INCOME_REPLACEMENT = "Income Replacement";